export default __webpack_public_path__ + "static/media/E01.d011283f.mp3";